/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetShippingLocationsRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {SetShippingLocationsResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const setShippingLocations = (request: SetShippingLocationsRequest, options?: CashRequestOptions) => post<SetShippingLocationsRequest, SetShippingLocationsResponse>("/2.0/cash/set-shipping-locations", request, {...options, rejectOnError: true })